import { CONTACT_DETAIL_ICON_GROUPS } from 'src/app/@shared/detail/detail-config';
import { DetailFieldsetKey } from 'src/app/@shared/detail/detail-fieldset-config';
import { DetailListItem, DetailListSubItem } from 'src/app/@shared/detail/detail-list-item/detail-list-item.component';

function applyIconGroups(subItems: DetailListSubItem[]): void {
  for (const group of CONTACT_DETAIL_ICON_GROUPS) {
    for (const fieldId of group.fieldIds) {
      const subItem = subItems.find((item) => { return item.id === fieldId; });

      if (subItem) {
        subItem.iconName = group.iconName;
        break;
      }
    }
  }
}

// Items have already been filtered for visibility and empty values by the detail mapper.
export function applyDetailIconGroups(items: DetailListItem[], fieldsetId: DetailFieldsetKey): void {
  if (fieldsetId === 'contactPersons') {
    for (const item of items) {
      applyIconGroups(item.subItems);
    }
  } else if (fieldsetId === 'contact' || fieldsetId === 'organization-co-information') {
    applyIconGroups(items.flatMap((item) => { return item.subItems; }));
  }
}
